(function () {
    if (typeof window.CustomEvent === 'function')
        return false;
    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: null };
        const evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }
    CustomEvent.prototype = window.Event.prototype;
    // @ts-ignore
    window.CustomEvent = CustomEvent;
})();
/**
 * Triggers a custom event
 * @param el
 * @param {string} type
 * @param params
 */
export default function triggerEvent(el, type, params = '') {
    let e = new CustomEvent(type, {
        detail: {
            extraParameteres: params
        },
        bubbles: true,
        cancelable: false
    });
    el.dispatchEvent(e);
}
